(() => {
  function initialize(root) {
    if (root.dataset.giftReady) return;
    root.dataset.giftReady = 'true';
    const config = JSON.parse(root.querySelector('[data-gift-config]').textContent);
    const status = root.querySelector('[data-gift-status]');
    const mainForm = Array.from(document.forms).find(form => !form.hasAttribute('data-gift-form') && form.getAttribute('action')?.split('?')[0].endsWith('/cart/add') && form.querySelector('[name="id"]'));
    if (!mainForm) return;
    let busy = false;
    const tripleForm = root.querySelector('[data-triple-form]');
    const tripleProducts = tripleForm ? JSON.parse(root.querySelector('[data-triple-products]').textContent) : [];
    const slots = tripleForm ? Array.from(tripleForm.querySelectorAll('[data-triple-slot]')) : [];
    slots.forEach(slot => {
      const productSelect = slot.querySelector('[data-triple-product]');
      const variantSelect = slot.querySelector('[data-triple-variant]');
      tripleProducts.forEach(product => productSelect.add(new Option(product.title, String(product.id))));
      productSelect.addEventListener('change', () => {
        variantSelect.replaceChildren(new Option(config.messages.variantPlaceholder, ''));
        const product = tripleProducts.find(product => String(product.id) === productSelect.value);
        product?.variants.forEach(variant => variantSelect.add(new Option(variant.title, String(variant.id))));
        variantSelect.disabled = !product;
        update();
      });
    });
    function mainVariant() {
      const id = mainForm.querySelector('[name="id"]').value;
      return config.variants.find(variant => String(variant.id) === String(id));
    }
    function update() {
      const main = mainVariant();
      root.querySelectorAll('[data-gift-form]').forEach(form => {
        const select = form.querySelector('[data-gift-variant]');
        const option = select.selectedOptions[0];
        const valid = main?.available && Boolean(select.value);
        form.querySelector('[data-gift-submit]').disabled = busy || !valid;
        const badge = form.querySelector('[data-gift-badge]');
        badge.hidden = !valid;
        if (valid) badge.textContent = Number(option.dataset.price) <= main.price ? config.messages.free : config.messages.lower;
      });
      if (tripleForm) {
        const valid = main?.available && slots.every(slot => Boolean(slot.querySelector('[data-triple-variant]').value));
        tripleForm.querySelector('[data-triple-submit]').disabled = busy || !valid;
        tripleForm.querySelector('[data-triple-summary]').textContent = valid ? config.messages.tripleSummary : '';
      }
    }
    if (tripleForm) tripleForm.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !tripleForm.reportValidity()) return;
      const main = mainVariant();
      const tripleStatus = tripleForm.querySelector('[data-triple-status]');
      if (!main?.available) {
        tripleStatus.textContent = config.messages.choose;
        update();
        return;
      }
      const ids = [main.id, ...slots.map(slot => Number(slot.querySelector('[data-triple-variant]').value))];
      if (ids.some(id => !id)) return;
      const quantities = new Map();
      ids.forEach(id => quantities.set(id, (quantities.get(id) || 0) + 1));
      busy = true;
      update();
      tripleStatus.textContent = config.messages.tripleBusy;
      try {
        const response = await fetch(root.dataset.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: Array.from(quantities, ([id, quantity]) => ({ id, quantity })) })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(config.messages.tripleError);
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        tripleStatus.textContent = config.messages.tripleError;
        busy = false;
        update();
      }
    });
    root.addEventListener('submit', async event => {
      const form = event.target.closest('[data-gift-form]');
      if (!form) return;
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      const main = mainVariant();
      if (!main?.available) {
        status.textContent = config.messages.choose;
        update();
        return;
      }
      const secondId = form.querySelector('[data-gift-variant]').value;
      if (!secondId) return;
      busy = true;
      update();
      status.textContent = config.messages.busy;
      try {
        const response = await fetch(root.dataset.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: main.id, quantity: 1 }, { id: Number(secondId), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || config.messages.error);
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent = config.messages.error;
        busy = false;
        update();
      }
    });
    document.addEventListener('change', () => window.setTimeout(update, 100));
    document.addEventListener('variant:change', update);
    update();
  }
  function scan() { document.querySelectorAll('[data-flaw-gift-pair]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();



